class DemoState {

    constructor() {

        this.isDemoMode = false
        this.user = ''
        this.demoStateKey = 'stk-demo'
        this.demoStateUserKey = 'stk-demo-user'
    }

    status() {
        if (typeof window !== "undefined" && typeof window.localStorage !== "undefined") {
            let status =  window.localStorage.getItem(this.demoStateKey)
            let user = window.localStorage.getItem(this.demoStateUserKey)

            return {
                status: JSON.parse(status), 
                user: JSON.parse(user)
            }
        }

        return false
    }


    turnOffDemoMode() {

        if (typeof window !== "undefined" && typeof window.localStorage !== "undefined") {
            window.localStorage.setItem(this.demoStateUserKey, JSON.stringify(null))
            window.localStorage.setItem(this.demoStateKey, JSON.stringify(false))
        }

    }

    //employee || store
    turnOnDemoMode(user = '') {
        if (typeof window !== "undefined" && typeof window.localStorage !== "undefined") {
            window.localStorage.setItem(this.demoStateKey, JSON.stringify(true))
            window.localStorage.setItem(this.demoStateUserKey, JSON.stringify(user))
        }
    }
}

export default new DemoState()